import { useEffect, useCallback, useRef } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useUnlinkedQuestionnaires = (appId, isExpanded) => {
  const { apiGet } = useApi();
  const useApiState = createApiHook([]);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetched = useRef(false);

  const fetchUnlinkedQuestionnaires = useCallback(async () => {
    if (!appId) return;
    startLoading();
    const response = await apiGet(`/aplicaciones/${appId}/unlinked_questionnaires`, "Error al obtener cuestionarios no relacionados");
    setResponse(response);
    return response?.data;
  }, [apiGet, appId, startLoading, setResponse]);

  useEffect(() => {
    if (isExpanded && !fetched.current) {
      fetched.current = true;
      fetchUnlinkedQuestionnaires();
    }
  }, [isExpanded, fetchUnlinkedQuestionnaires]);

  return {
    data,
    error,
    loading,
    refetch: fetchUnlinkedQuestionnaires,
  };
};

export default useUnlinkedQuestionnaires;
